<template>
  <div class="page">
    <div class="top-part">
      <!-- 联系我们 -->
      <div class="concat">
        <div class="logo-part">
          <img loading="lazy" class="logo" src="@/assets/foot/logo_white.png" alt="云码通Logo" />
        </div>
        <div class="detail" v-for="(item, index) in detailDatas" :key="index">
          <h4>{{ item.label }}</h4>
          <p>{{ item.value }}</p>
        </div>
        <div class="code-part">
          <h4>关注我们</h4>
          <div class="icons">
            <div v-for="(item, index) in codeDatas" :key="index" class="icon-item">
              <el-popover placement="top" trigger="hover">
                <div class="code-detail">
                  <img loading="lazy" :src="item.url" />
                  <p>{{ item.name }}</p>
                </div>
                <img loading="lazy" slot="reference" :src="item.icon" alt="item.name" />
              </el-popover>
            </div>
          </div>
        </div>
      </div>

      <!-- 快速导览 -->
      <div class="guide">
        <div class="guide-column" v-for="(group, groupIndex) in guideList" :key="groupIndex">
          <h3 class="guide-title">{{ group.name }}</h3>
          <ul class="guide-links">
            <li v-for="(item, itemIndex) in group.pageList" :key="itemIndex">
              <a @click="
                handleGuide(group.pageName || item.pageName, item.model)
                ">
                {{ item.name }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 版权声明 -->
    <div class="bottom-part">
      <span style="cursor: pointer" @click="toGongXinBu">
        Copyright©2022 深圳云码通科技有限公司 粤ICP备{{ icpNumber }}
      </span>
    </div>

    <!-- 回到顶部 -->
    <el-backtop>
      <div style="height: 100%; width: 100%" class="up">
        <img loading="lazy" src="@/assets/foot/up.png" alt="回到顶部" />
      </div>
    </el-backtop>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "Foot",
  data() {
    return {
      detailDatas: [
        {
          label: '地址',
          value: '深圳市龙华区大浪街道鹊山路8号企生活AI数字谷1栋B-505号',
        },
        {
          label: '电话',
          value: '18682463859',
        },
        {
          label: '邮箱',
          value: 'service@ymtdata.com (邮编：518000)',
        },
      ],
      codeDatas: [
        {
          url: require('@/assets/foot/douyin.png'),
          name: '抖音官方账号',
          icon: require('@/assets/foot/icon/douyin.png')
        },
        {
          url: require('@/assets/foot/code.png'),
          name: '公众号账号',
          icon: require('@/assets/foot/icon/code.png')
        },
        {
          url: require('@/assets/foot/wechat.png'),
          name: '客服联系',
          icon: require('@/assets/foot/icon/wechat.png')
        },
        {
          url: require('@/assets/foot/concat.png'),
          name: '商务联系',
          icon: require('@/assets/foot/icon/concat.png')
        },
      ],
      guideList: [
        {
          name: "智慧工厂",
          pageName: 'SmartFactory',
          pageList: [
            { name: '纸箱缺陷检测设备', model: 'Carton' },
            { name: '线缆表面缺陷检测', model: 'Cable' },
            { name: '模切套准识别平台', model: 'DieCutting' },
            { name: '光纤线序检测仪', model: 'OpticalFiber' },
            { name: '洗手流程检测', model: 'WashHands' },
            { name: '智能烟头检测系统', model: 'CigaretteButt' },
          ]
        },
        {
          name: "机器人",
          pageName: 'Robot',
          pageList: [
            { name: '龙马一号激光导航室外巡检机器人', model: 'LM-1' },
            { name: '龙马二号远程驾驶室外巡逻机器人', model: 'LM-2' },
            { name: '龙马四号室内巡检机器人', model: 'LM-4' },
            { name: '吊轨巡检机器人', model: 'LM-D1' },
            { name: '光伏板清扫机器人', model: 'LM-G1' },
          ]
        },
        // {
        //   name:"数字人",
        //   pageList:[
        //     { name:'自主移动AI数字人', pageName:'Mobile' },
        //     { name:'全息仓AI数字人', pageName:'Holography' },
        //     { name:'龙小伴AI数字人', pageName:'Phone' },
        //   ]
        // },
        {
          name: "快速入口",
          pageList: [
            { name: '关于我们', pageName: 'AboutUS' },
            { name: '加入我们', pageName: 'JoinUS' },
          ]
        },
      ]
    }
  },
  methods: {
    toGongXinBu() {
      window.open('https://beian.miit.gov.cn', '_blank');
    },
    handleGuide(url, model) {
      if (url === 'Robot') {
        this.$router.push({
          name: url,
          query: { model }
        });
      } else if (url === 'SmartFactory') {
        this.$router.push({
          name: url,
          query: { model }
        }).then(() => {
          window.scrollTo(0, 0);
        });;
      } else {
        this.$router.push({
          name: url
        }).then(() => {
          window.scrollTo(0, 0);
        });
      }
    }
  },
  computed: {
    icpNumber() {
      const host = window.location.hostname;
      if (host.indexOf('ymtdata.com') !== -1) {
        return '16005622号-1';
      } else if (host.indexOf('ymtdata.cn') !== -1) {
        return '16005622号-6';
      } else {
        return '16005622号-1';
      }
    },
  }
}
</script>

<style scoped lang="scss">
.page {
  background-color: #2a7bdc;
  color: #fff;
}

.top-part {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  gap: 3rem;

  .concat {
    display: flex;
    flex-direction: column;

    .logo-part {
      img {
        margin-top: 1.9rem;
        width: 9.6rem;
        height: 2.7rem;
        cursor: pointer;
      }
    }

    .detail {
      h4 {
        font-size: 18px;
        margin-bottom: 10px;
      }

      p {
        font-size: 1.6rem;
        margin: 0;
        line-height: 1.6;
        color: rgba(255, 255, 255, 0.6);
      }
    }

    .code-part {
      margin-bottom: 20px;

      h4 {
        font-size: 16px;
        margin-bottom: 15px;
      }

      .icons {
        display: flex;
        gap: 15px;

        .icon-item {
          width: 40px;
          height: 40px;
          background-color: #666f80;
          border-radius: 50%;
          padding: 1rem;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }

          &:hover {
            background-color: #414854;
          }
        }
      }
    }
  }

  .guide {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    margin-top: 40px;

    .guide-column {
      min-width: 120px;

      .guide-title {
        font-size: 18px;
        margin-bottom: 15px;
      }

      .guide-links {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          margin-bottom: 10px;
        }

        a {
          color: rgba(255, 255, 255, 0.6);
          text-decoration: none;
          font-size: 1.6rem;
          transition: color 0.3s;
          cursor: pointer;

          &:hover {
            color: #fff;
          }
        }
      }
    }
  }
}

.bottom-part {
  font-size: 12px;
  max-width: 1200px;
  margin: 0 auto;
  border-top: 1px solid rgba(208, 208, 208, 0.5);
  padding: 15px 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);

  span {
    transition: color 0.3s;

    &:hover {
      color: #fff;
    }
  }
}

// 回到顶部样式
.el-backtop {
  width: 55px;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;

  .up {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 50px;
      height: 50px;
    }
  }
}

@media screen and (max-width: 768px) {
  .top-part {
    padding: 0 1.5rem;

    .concat {
      .logo-part {
        margin-bottom: 20px;

        img {
          width: 8rem;
          height: auto;
        }
      }

      .detail {
        margin-right: 0;

        h4 {
          font-size: 16px;
        }

        p {
          font-size: 1.4rem;
        }
      }

      .code-part {
        h4 {
          font-size: 16px;
          display: inline-block;
        }

        .icons {
          gap: 10px;

          .icon-item {
            width: 35px;
            height: 35px;
            padding: 0.8rem;
          }
        }
      }
    }

    .guide {
      display: none;
    }
  }

  .bottom-part {
    padding: 10px;
    font-size: 11px;

    span {
      display: block;
      line-height: 1.5;
    }
  }

  .el-backtop {
    width: 40px;
    height: 40px;

    .up img {
      width: 30px;
      height: 30px;
    }
  }
}
</style>

<style lang="scss">
.el-popover {
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 1.5rem 0;

  .code-detail {
    padding: 0;
    text-align: center;

    img {
      width: 100px;
    }

    p {
      padding: 0;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue